<template>
  <div class="admin-dashboard">
    <el-row :gutter="20">
      <el-col :span="6" v-for="stat in stats" :key="stat.title">
        <el-card class="stat-card">
          <div class="stat-content">
            <div class="stat-value">{{ stat.value }}</div>
            <div class="stat-title">{{ stat.title }}</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import api from '../../api'

export default {
  name: 'AdminDashboard',
  data() {
    return {
      stats: [
        { title: '市场资源', value: 0 },
        { title: '工具数量', value: 0 },
        { title: '新闻数量', value: 0 },
        { title: '总浏览量', value: 0 }
      ]
    }
  },
  mounted() {
    this.loadStats()
  },
  methods: {
    async loadStats() {
      try {
        // 加载市场资源数量
        const marketRes = await api.get('/admin/market/items/')
        this.stats[0].value = Array.isArray(marketRes.data) ? marketRes.data.length : (marketRes.data.results?.length || 0)

        // 加载工具数量
        const toolsRes = await api.get('/admin/tools/items/')
        this.stats[1].value = Array.isArray(toolsRes.data) ? toolsRes.data.length : (toolsRes.data.results?.length || 0)

        // 加载新闻数量
        const newsRes = await api.get('/admin/news/items/')
        this.stats[2].value = Array.isArray(newsRes.data) ? newsRes.data.length : (newsRes.data.results?.length || 0)

        // 计算总浏览量（这里简化处理，实际可以从统计数据获取）
        this.stats[3].value = '-'
      } catch (error) {
        console.error('加载统计数据失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.admin-dashboard {
  width: 100%;
}

.stat-card {
  background-color: rgba(20, 20, 30, 0.9);
  border-color: rgba(0, 150, 255, 0.3);
}

.stat-content {
  text-align: center;
  padding: 20px 0;
}

.stat-value {
  font-size: 36px;
  font-weight: bold;
  color: #00d4ff;
  margin-bottom: 10px;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
}

.stat-title {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

</style>

